import { BaseUseCase } from "../UseCaseBase";
class CircularUpdateUseCase extends BaseUseCase {
    constructor(FooterRepository) {
        super();
        this.FooterRepository = FooterRepository;
    }
    fetchResult(req) {
        return this.FooterRepository.getCircularUpdate(req);
    }
}
export default CircularUpdateUseCase;
